<template>
  <small v-if="billingEntitlementsReady" class="billing-feature-hint p-text-secondary">
    <i v-if="showLock" class="ti-lock p-mr-1"/>
    <slot :plan="requiredPlan" :message="hintText">
      {{ hintText }}
    </slot>
    <a v-if="showChangePlan && canOpenSubscriptions"
       href="#"
       class="p-ml-1"
       draggable="false"
       @click.prevent="openBillingFeaturePlans(feature)">
      {{ $t('billing.featureGate.changePlanLabel') }}
    </a>
  </small>
</template>

<script>
import billingFeaturesMixins from '@/mixins/billingFeaturesMixins'

export default {
  name: 'BillingFeatureHint',

  mixins: [billingFeaturesMixins],

  props: {
    feature: {
      type: String,
      required: true,
    },
    messageKey: {
      type: String,
      default: 'billing.featureGate.availableFromPlanLabel',
    },
    showLock: {
      type: Boolean,
      default: true,
    },
    showChangePlan: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    canOpenSubscriptions() {
      return (
          this.$store.getters.isOwnerOrHigher &&
          !this.$store.getters.isCurrentLocationBillingLocked &&
          !!this.$store.getters.currentLocationPlanKey
      )
    },
    requiredPlan() {
      return this.billingRequiredPlanKey(this.feature)
    },
    hintText() {
      const text = String(
          this.$t(this.messageKey, { plan: this.requiredPlan })
      ).trim()

      return /[.!?…]$/.test(text) ? text : `${text}.`
    },
  },
}
</script>